import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { paymentAPI } from '../services/api';
import { StatCard, Badge, Spinner, EmptyState, PageHeader } from '../components/Common';

const PaymentsPage = () => {
  const [data,       setData]       = useState(null);
  const [loading,    setLoading]    = useState(true);
  const [activeTab,  setActiveTab]  = useState('pending');
  const [updating,   setUpdating]   = useState(null);

  const load = async () => {
    try {
      const res = await paymentAPI.getAll();
      setData(res.data);
    } catch { toast.error('Payments load nahi hue'); }
    finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const handleStatusUpdate = async (invoiceId, newStatus) => {
    setUpdating(invoiceId);
    try {
      await paymentAPI.updateStatus(invoiceId, newStatus);
      toast.success(`Payment ${newStatus} mark ho gaya! ✅`);
      load();
    } catch { toast.error('Update nahi hua'); }
    finally { setUpdating(null); }
  };

  if (loading) return <Spinner />;

  const { invoices = [], customer_pending = [], summary = {} } = data || {};

  const pendingInvoices = invoices.filter(i => i.payment_status === 'pending');
  const paidInvoices    = invoices.filter(i => i.payment_status === 'paid');
  const partialInvoices = invoices.filter(i => i.payment_status === 'partial');

  const statusBadge = (status) => {
    if (status === 'paid')    return <Badge variant="green">✅ Paid</Badge>;
    if (status === 'pending') return <Badge variant="red">⏳ Pending</Badge>;
    if (status === 'partial') return <Badge variant="orange">🔄 Partial</Badge>;
    return <Badge variant="gray">{status}</Badge>;
  };

  return (
    <div className="page">
      <PageHeader
        title="💰 Payment Management"
        subtitle="Customer-wise payment track karo"
      />

      {/* Stats */}
      <div className="stats-grid gstr-grid">
        {/* Pending Amount */}
        <div className="stats-container">
          <div className="stat-card stat-red">
            <div className="icon">⏳</div>
            <div className="details">
              <div className="value">
                ₹{(summary.total_pending || 0).toLocaleString('en-IN')}
              </div>
              <div className="label">Pending Amount</div>
              <div className="sub-text">
                {summary.pending_count || 0} invoices
              </div>
            </div>
          </div>

          {/* Paid Amount */}
          <div className="stat-card stat-green">
            <div className="icon">✅</div>
            <div className="details">
              <div className="value">
                ₹{(summary.total_paid || 0).toLocaleString('en-IN')}
              </div>
              <div className="label">Paid Amount</div>
              <div className="sub-text">
                {summary.paid_count || 0} invoices
              </div>
            </div>
          </div>

          {/* Pending Customers */}
          <div className="stat-card stat-orange">
            <div className="icon">👥</div>
            <div className="details">
              <div className="value">
                {customer_pending.length}
              </div>
              <div className="label">Pending Customers</div>
              <div className="sub-text">
                Payment baaki hai
              </div>
            </div>
          </div>

          {/* Total Revenue */}
          <div className="stat-card stat-blue">
            <div className="icon">💰</div>
            <div className="details">
              <div className="value">
                ₹{((summary.total_pending || 0) + (summary.total_paid || 0)).toLocaleString('en-IN')}
              </div>
              <div className="label">Total Revenue</div>
              <div className="sub-text">
                All invoices
              </div>
            </div>
          </div>
        </div>

        {/* <StatCard icon="⏳" label="Pending Amount"
          value={`₹${(summary.total_pending||0).toLocaleString('en-IN')}`}
          sub={`${summary.pending_count||0} invoices`}
          color="red" />
        <StatCard icon="✅" label="Paid Amount"
          value={`₹${(summary.total_paid||0).toLocaleString('en-IN')}`}
          sub={`${summary.paid_count||0} invoices`}
          color="green" />
        <StatCard icon="👥" label="Pending Customers"
          value={customer_pending.length}
          sub="Payment baaki hai"
          color="orange" />
        <StatCard icon="💰" label="Total Revenue"
          value={`₹${((summary.total_pending||0) + (summary.total_paid||0)).toLocaleString('en-IN')}`}
          sub="All invoices"
          color="blue" /> */}
      </div>

      {/* Customer wise Pending */}
      {customer_pending.length > 0 && (
        <div className="card" style={{ marginBottom: 20 }}>
          <div className="card-header">
            <span className="card-title">👥 Customer-wise Pending</span>
          </div>
          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>Customer</th><th>Phone</th>
                  <th>Pending Invoices</th><th>Total Pending</th><th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {customer_pending.map(c => (
                  <tr key={c.customer_id}>
                    <td><strong>{c.customer_name}</strong></td>
                    <td>{c.phone}</td>
                    <td><Badge variant="red">{c.invoices.length} invoices</Badge></td>
                    <td>
                      <strong style={{ color: 'var(--danger)', fontSize: 15 }}>
                        ₹{Math.round(c.total_pending).toLocaleString('en-IN')}
                      </strong>
                    </td>
                    <td>
                      {c.whatsapp && c.whatsapp !== '-' && (
                        <button
                            className="btn btn-success btn-sm"
                            onClick={() => {
                            var msg = 'Dear ' + c.customer_name + ', aapka Rs.' + Math.round(c.total_pending) + ' Payment is pending. Please complete the payment - Bhamsa';
                            window.open('https://wa.me/91' + c.whatsapp + '?text=' + encodeURIComponent(msg), '_blank');
                            }}
                        >
                            📱 Remind Karo
                        </button>
                        )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Tabs */}
      <div className="tabs">
        <button className={`tab ${activeTab==='pending'?'active':''}`} onClick={() => setActiveTab('pending')}>
          ⏳ Pending ({pendingInvoices.length})
        </button>
        <button className={`tab ${activeTab==='partial'?'active':''}`} onClick={() => setActiveTab('partial')}>
          🔄 Partial ({partialInvoices.length})
        </button>
        <button className={`tab ${activeTab==='paid'?'active':''}`} onClick={() => setActiveTab('paid')}>
          ✅ Paid ({paidInvoices.length})
        </button>
        <button className={`tab ${activeTab==='all'?'active':''}`} onClick={() => setActiveTab('all')}>
          📋 All ({invoices.length})
        </button>
      </div>

      {/* Invoices Table */}
      <div className="card">
        <div className="table-wrap">
          {(activeTab==='pending' ? pendingInvoices
            : activeTab==='partial' ? partialInvoices
            : activeTab==='paid' ? paidInvoices
            : invoices).length === 0 ? (
            <EmptyState icon="💰" title="No invoices found." message="No invoices found in this category" />
          ) : (
            <table>
              <thead>
                <tr>
                  <th>Invoice</th><th>Customer</th><th>Amount</th>
                  <th>Status</th><th>Date</th><th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {(activeTab==='pending' ? pendingInvoices
                  : activeTab==='partial' ? partialInvoices
                  : activeTab==='paid' ? paidInvoices
                  : invoices).map(inv => (
                  <tr key={inv.id}>
                    <td style={{ color:'var(--accent)', fontWeight:600 }}>
                      {inv.invoice_number}
                    </td>
                    <td>
                      <div>{inv.customer?.name || 'Walk-in'}</div>
                      {inv.customer?.phone && (
                        <div style={{ fontSize:11, color:'var(--text3)' }}>
                          {inv.customer.phone}
                        </div>
                      )}
                    </td>
                    <td style={{ fontWeight:700, color:'var(--accent2)' }}>
                      ₹{parseFloat(inv.total_amount).toLocaleString('en-IN')}
                    </td>
                    <td>{statusBadge(inv.payment_status)}</td>
                    <td style={{ fontSize:12, color:'var(--text2)' }}>
                      {new Date(inv.createdAt).toLocaleDateString('en-IN')}
                    </td>
                    <td>
                      <div style={{ display:'flex', gap:6 }}>
                        {inv.payment_status !== 'paid' && (
                          <button
                            className="btn btn-success btn-sm"
                            disabled={updating === inv.id}
                            onClick={() => handleStatusUpdate(inv.id, 'paid')}
                          >
                            ✅ Mark as Paid
                          </button>
                        )}
                        {inv.payment_status === 'pending' && (
                          <button
                            className="btn btn-warning btn-sm"
                            disabled={updating === inv.id}
                            onClick={() => handleStatusUpdate(inv.id, 'partial')}
                          >
                            🔄 Partial
                          </button>
                        )}
                        {inv.payment_status === 'paid' && (
                          <button
                            className="btn btn-ghost btn-sm"
                            disabled={updating === inv.id}
                            onClick={() => handleStatusUpdate(inv.id, 'pending')}
                          >
                            ↩ Pending
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default PaymentsPage;